// extracted by css-extract-rspack-plugin
export default {"sidebarLogoRoot":"sBby0JQA5C4uR7zO","sidebarLogoLink":"KQ949vB8MwUaOMNt","sidebarLogoLinkOpen":"KTFz25eshLUE_ZsA"};